
const params = [
	'utm_campaign',
	'utm_source',
]

// Capture url params and save to local storage
const urlParams = new URLSearchParams(window.location.search)
params.forEach(key => {
	if (urlParams.has(key)) {
		const campaign = urlParams.get(key)
		localStorage.setItem(key, campaign)
	}
})

// look for hidden fields in forms (Salesforce or Elementor) and get value from localStorage
var field = document.getElementById('form-field-Campaign_Name__c')
var campaign = localStorage.getItem('utm_campaign')
var campaignSource = localStorage.getItem('utm_source')
if(field && campaign && campaignSource){
    field.value = campaign + ' - ' + campaignSource
} else if(field){
    field.value = 'none'
}
